import { render, staticRenderFns } from "./IcoFaceSmile.vue?vue&type=template&id=33bc2498"
import script from "./IcoFaceSmile.vue?vue&type=script&lang=js"
export * from "./IcoFaceSmile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports